import { render, staticRenderFns } from "./car.vue?vue&type=template&id=17501d16&scoped=true&"
import script from "./car.vue?vue&type=script&lang=js&"
export * from "./car.vue?vue&type=script&lang=js&"
import style0 from "./car.vue?vue&type=style&index=0&id=17501d16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17501d16",
  null
  
)

export default component.exports